import { ONGLET_EMPLOYEUR, ONGLET_FORMATION } from "../shared"

export const OngletsCPRO = [ONGLET_EMPLOYEUR, 'Salarie', 'Contrat', ONGLET_FORMATION] as const
export type OngletCPRO = (typeof OngletsCPRO)[number]

export const OngletsCPROLibellés: Record<OngletCPRO, string> = {
  Employeur: 'Employeur',
  Salarie: 'Salarié',
  Contrat: 'Contrat',
  Formation: 'Formation',
}

